import { http } from '../../../axios';
import { localContentPrefix } from '../../../../config';
import { LanguageOut } from '../../../../store/apiLibx';

export const fetchLocalContentLanguages = () => {
    return http
        .get<{ languages: LanguageOut[] }>(`${localContentPrefix}/v1/localcontent/languages`)
        .then(response => response.data.languages);
};
